// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../App.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.project-main {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 30px;
  width: 100%;
  position: relative;
  background: var(--dark);
  padding: 40px;
  padding-bottom: 100px;
  box-sizing: border-box;
  animation: page-appear-from-left 0.8s ease;
}

@keyframes page-appear-from-left {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(0);
  }
}
.bento-grid {
  display: grid;
  grid-template-columns: 35% 60%;
  gap: 2%;
  width: 100%;
  justify-content: center;
  align-items: start;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  padding: 20px 10px;
  border-radius: 12px;
}

.bento-grid .container {
  display: flex;
  flex: 1 1;
  justify-content: flex-start;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
  gap: 30px;
  padding: 20px;
  background: var(--very-dark-green);
  border-radius: 10px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.7);
  transition: all 0.3s ease;

  &.column {
    flex-direction: column;
    gap: 20px;
  }

  &.reduced-space {
    gap: 10px;
    flex-direction: column;
    justify-content: center;
  }
}

@media (max-width: 700px) {
  .project-main {
    padding: 10px;
    gap: 10px;
    padding-bottom: 50px;
    box-sizing: border-box;
  }
  .bento-grid {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 10px;
    width: 100%;
    box-sizing: border-box;
    padding: 15px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/routes/Projects/Projects.css"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,qBAAqB;EACrB,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,wBAAwB;EAC1B;AACF;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,OAAO;EACP,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAO;EACP,2BAA2B;EAC3B,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,SAAS;EACT,aAAa;EACb,kCAAkC;EAClC,mBAAmB;EACnB,+CAA+C;EAC/C,yBAAyB;;EAEzB;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,SAAS;IACT,sBAAsB;IACtB,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,aAAa;IACb,SAAS;IACT,oBAAoB;IACpB,sBAAsB;EACxB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,WAAW;IACX,sBAAsB;IACtB,aAAa;EACf;AACF","sourcesContent":["@import url(\"/src/App.css\");\n\n.project-main {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 30px;\n  width: 100%;\n  position: relative;\n  background: var(--dark);\n  padding: 40px;\n  padding-bottom: 100px;\n  box-sizing: border-box;\n  animation: page-appear-from-left 0.8s ease;\n}\n\n@keyframes page-appear-from-left {\n  0% {\n    transform: translateX(-100%);\n  }\n  100% {\n    transform: translateX(0);\n  }\n}\n.bento-grid {\n  display: grid;\n  grid-template-columns: 35% 60%;\n  gap: 2%;\n  width: 100%;\n  justify-content: center;\n  align-items: start;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.3);\n  padding: 20px 10px;\n  border-radius: 12px;\n}\n\n.bento-grid .container {\n  display: flex;\n  flex: 1;\n  justify-content: flex-start;\n  align-items: center;\n  box-sizing: border-box;\n  width: 100%;\n  gap: 30px;\n  padding: 20px;\n  background: var(--very-dark-green);\n  border-radius: 10px;\n  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.7);\n  transition: all 0.3s ease;\n\n  &.column {\n    flex-direction: column;\n    gap: 20px;\n  }\n\n  &.reduced-space {\n    gap: 10px;\n    flex-direction: column;\n    justify-content: center;\n  }\n}\n\n@media (max-width: 700px) {\n  .project-main {\n    padding: 10px;\n    gap: 10px;\n    padding-bottom: 50px;\n    box-sizing: border-box;\n  }\n  .bento-grid {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    gap: 10px;\n    width: 100%;\n    box-sizing: border-box;\n    padding: 15px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
